import moment from 'moment';

export const getLastMonthRangeExcludingToday = (): { startDate: string; endDate: string } => {
  const endDate = moment().subtract(1, 'day'); // Ayer
  const startDate = moment(endDate).subtract(1, 'months');

  return {
    startDate: startDate.format('DD/MM/YYYY'),
    endDate: endDate.format('DD/MM/YYYY'),
  };
};